export const loginiam = {
    emergencyStopMsg: '現在メンテナンス中のため、しばらくの間ご利用いただけません',
    terminatedMsg: '無効なアカウントです'
}
